import {
  Component,
  ComponentRef,
  EventEmitter,
  Injector,
  OnInit,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { Toastable, ToastRefList } from './toast-container.types';
import { CustomToastService } from 'src/app/services/custom-toast.service';
import { Subject, take } from 'rxjs';

@Component({
  selector: 'app-toast-container',
  templateUrl: './toast-container.component.html',
  styleUrls: ['./toast-container.component.scss'],
})
export class ToastContainerComponent implements OnInit {
  @ViewChild('toastContainer', { read: ViewContainerRef, static: true })
  toastContainer!: ViewContainerRef;

  public toastRefList: ToastRefList = [];
  private readonly animationDuration = 200;

  constructor(private readonly injector: Injector) {}

  ngOnInit(): void {
    return;
  }

  addToast<TComp, TRes>(
    componentRef: ComponentRef<TComp>,
    id: number
  ): Subject<TRes | null> {
    this.toastRefList.push({ ref: componentRef, id });
    this.toastContainer.insert(componentRef.hostView);
    const nativeElement = (componentRef.hostView as any).rootNodes[0];
    if (nativeElement) {
      nativeElement.classList.add('fade-in');
    }
    return (componentRef.instance as Toastable<TRes | null>).dismissAsToast;
  }

  dismissToast(id: number) {
    const toastIndex = this.toastRefList.findIndex((t) => t.id === id);
    if (toastIndex !== -1) {
      const toastRef = this.toastRefList[toastIndex];
      const nativeElement = (toastRef.ref.hostView as any).rootNodes[0];
      if (nativeElement) {
        nativeElement.classList.replace('fade-in', 'fade-out');
        setTimeout(() => {
          this.toastContainer.remove(
            this.toastContainer.indexOf(toastRef.ref.hostView)
          );
          this.toastRefList.splice(toastIndex, 1);
        }, this.animationDuration);
      } else {
        this.toastContainer.remove(
          this.toastContainer.indexOf(toastRef.ref.hostView)
        );
        this.toastRefList.splice(toastIndex, 1);
      }
    }
  }
}
